import { useEffect, useState } from "react";

export const ApiSpeedIndicator = () => {
  const [t, setT] = useState(null);
  useEffect(() => {
    const h = (e) => setT(e.detail);
    window.addEventListener("api-timing", h);
    return () => window.removeEventListener("api-timing", h);
  }, []);
  if (!t) return null;
  const network = Math.max(t.total - (t.server ?? 0), 0);
  const color = t.total < 400
    ? "text-emerald-400 border-emerald-400/30"
    : t.total < 1200
      ? "text-amber-400 border-amber-400/40"
      : "text-rose-400 border-rose-400/40";
  return (
    <div data-testid="api-speed-indicator"
      title="Tempo da última requisição ao sistema. Servidor = processamento no CRM; rede = sua internet até o servidor. Se ambos estiverem baixos e a tela ainda parecer lenta, a lentidão é do seu dispositivo/navegador."
      className={`fixed right-2 z-40 border rounded-full px-2.5 py-1 text-[10px] font-medium bg-zinc-950/90 backdrop-blur select-none pointer-events-auto bottom-[calc(4rem+env(safe-area-inset-bottom))] lg:bottom-2 ${color}`}>
      servidor {t.server != null ? `${t.server}ms` : "—"} · rede {network}ms
    </div>
  );
};
